import React from 'react';
import { UsersIcon, HeartOffIcon } from 'lucide-react';
export const EvidenceSection = () => {
  return <section className="w-full bg-[#faf7f2] py-16 px-4 md:px-8 lg:px-16" data-id="element-63">
      <div className="max-w-6xl mx-auto" data-id="element-64">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-65">
          <div className="md:w-1/2" data-id="element-66">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rA9EsIeAiZEvc4A9xMwBQeFXysqnHCS1zaOuYl" alt="Kobieta analizująca statystyki" className="w-full h-auto rounded-lg shadow-lg" data-id="element-67" />
          </div>
          <div className="md:w-1/2" data-id="element-68">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-69">
              Nie jesteś sama - dane mówią same za siebie
            </h2>
            <p className="text-lg text-gray-700 mb-8" data-id="element-70">
              Najnowsze badania GUS i Instytutu Badań Małżeństwa pokazują
              alarmujące statystyki dotyczące związków z długim stażem:
            </p>
            <div className="space-y-6" data-id="element-71">
              <div className="flex items-start gap-4" data-id="element-72">
                <div className="bg-red-500 p-3 rounded-full text-white" data-id="element-73">
                  <div size={24} data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <p className="text-3xl font-bold text-gray-800 mb-1" data-id="element-76">63%</p>
                  <p className="text-gray-700" data-id="element-77">
                    małżeństw z 15+ letnim stażem doświadcza kryzysu intymności
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-78">
                <div className="bg-red-500 p-3 rounded-full text-white" data-id="element-79">
                  <UsersIcon size={24} data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <p className="text-3xl font-bold text-gray-800 mb-1" data-id="element-82">78%</p>
                  <p className="text-gray-700" data-id="element-83">
                    kobiet po 40. roku życia czuje się niedocenianych przez
                    partnerów
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-84">
                <div className="bg-red-500 p-3 rounded-full text-white" data-id="element-85">
                  <HeartOffIcon size={24} data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <p className="text-3xl font-bold text-gray-800 mb-1" data-id="element-88">42%</p>
                  <p className="text-gray-700" data-id="element-89">
                    par powyżej 40. roku życia współżyje rzadziej niż raz w
                    miesiącu
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};